//#region Styles
import {
    ContainerParts, 
    Part, Row,
    TitleSection, ResumeSection 
} from "components/styles";
//#endregion
//#region Components
import ResumeStep1 from "./components/ResumeStep1/ResumeStep1";
import ModifyFile from "./components/ModifyFile/ModifyFile";
import { useEffect } from "react";
//#endregion

const Step2 = ({
    form, errors,
    errorStack,
    setCanShowDialogLeavingPage 
}) => {
    useEffect(() => {
        setCanShowDialogLeavingPage(true);
    });
    const changeFieldFileData = value => {
        form.change("fileData", value, false);
    }
    return (
        <ContainerParts>
            <Part gap="20px">
                <Row>
                    <TitleSection>Resumen del refuerzo:</TitleSection>
                </Row>
                <ResumeSection>
                    <ResumeStep1 
                        form={form.value}
                        errorStack={errorStack}/>
                    {(errorStack.stack.length > 0 || errorStack.rowCountFile === 0) && 
                        <ModifyFile
                            form={form.value}
                            changeForm={changeFieldFileData}
                            errors={errors}/>}
                </ResumeSection>
            </Part>
        </ContainerParts>
    );
}

export default Step2;